import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = [];

    connect() {
        console.log("icm dashboard controller connected");
    }

    openManualCampaignCreationDialog() {
        // Find the manual campaign creation controller and trigger its dialog opening
        const manualCampaignCreationController = this.application.getControllerForElementAndIdentifier(
            document.querySelector('[data-controller*="icm-manual-campaign-creation"]'),
            "icm-manual-campaign-creation",
        );

        if (manualCampaignCreationController) {
            manualCampaignCreationController.openManualCampaignCreationDialog();
        }
    }

    toggleJobIdsList(event) {
        const button = event.currentTarget;
        const campaignId = button.getAttribute("data-campaign-id");
        const additionalJobIds = document.querySelector(`.additional-job-ids[data-campaign-id="${campaignId}"]`);
        const expandText = button.querySelector(".expand-text");
        const collapseText = button.querySelector(".collapse-text");
        const icon = button.querySelector("svg");

        if (additionalJobIds.classList.contains("tw-hidden")) {
            // Expand the list
            additionalJobIds.classList.remove("tw-hidden");
            expandText.classList.add("tw-hidden");
            collapseText.classList.remove("tw-hidden");
            icon.style.transform = "rotate(180deg)";
        } else {
            // Collapse the list
            additionalJobIds.classList.add("tw-hidden");
            expandText.classList.remove("tw-hidden");
            collapseText.classList.add("tw-hidden");
            icon.style.transform = "rotate(0deg)";
        }
    }

    copyJobId(event) {
        const button = event.currentTarget;
        const jobId = button.getAttribute("data-job-id");

        // Copy to clipboard
        navigator.clipboard
            .writeText(jobId)
            .then(() => {
                // Visual feedback
                const originalTitle = button.getAttribute("title");
                button.setAttribute("title", "Kopiert!");
                button.classList.add("tw-text-joboo-green-default");

                // Reset after 2 seconds
                setTimeout(() => {
                    button.setAttribute("title", originalTitle);
                    button.classList.remove("tw-text-joboo-green-default");
                }, 2000);
            })
            .catch((err) => {
                console.error("Failed to copy job ID:", err);
                // Fallback for older browsers
                const textArea = document.createElement("textarea");
                textArea.value = jobId;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand("copy");
                document.body.removeChild(textArea);

                // Visual feedback
                const originalTitle = button.getAttribute("title");
                button.setAttribute("title", "Kopiert!");
                button.classList.add("tw-text-joboo-green-default");

                setTimeout(() => {
                    button.setAttribute("title", originalTitle);
                    button.classList.remove("tw-text-joboo-green-default");
                }, 2000);
            });
    }
}
